import React from "react";
import Box from "../../../components/Box";
import styled from "styled-components";

const EachBookingContainer = ({ children, onClick, isHeader }) => {
  return (
    <Box boxBorder="0rem" boxColor={isHeader && "transparent"}>
      <BookingBoxInner isHeader={isHeader} onClick={onClick}>
        {children}
      </BookingBoxInner>
    </Box>
  );
};

export default EachBookingContainer;

const BookingBoxInner = styled.div`
  padding: ${(props) => (props.isHeader ? "1rem 2rem" : "2rem")};
  display: grid;
  align-items: center;
  grid-template-columns: repeat(auto-fit, minmax(0rem, 1fr));
  gap: 1rem;
  cursor: pointer;
`;
